module.exports = __webpack_public_path__ + "static/media/you.f3035e5b.svg";